import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "w100" }
const _hoisted_2 = { style: {"height":"100vh","padding-top":"110px"} }
const _hoisted_3 = {
  key: 0,
  class: "with_white_bg pad40"
}
const _hoisted_4 = { class: "w100 mb20" }
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  class: "w30 fl ofh",
  style: {"min-width":"300px","height":"calc(100vh - 110px)"}
}
const _hoisted_11 = {
  class: /*#__PURE__*/_normalizeClass(`w70 fl ofh`),
  style: {"height":"calc(100vh - 110px)"}
}
const _hoisted_12 = { key: 2 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue3_progress_bar = _resolveComponent("vue3-progress-bar")!
  const _component_FlashNotice = _resolveComponent("FlashNotice")!
  const _component_LinkHeaderAvailableSchedule = _resolveComponent("LinkHeaderAvailableSchedule")!
  const _component_AstagClientLists = _resolveComponent("AstagClientLists")!
  const _component_RoomsLoader = _resolveComponent("RoomsLoader")!
  const _component_AppointmentCardViewSmall = _resolveComponent("AppointmentCardViewSmall")!
  const _component_ConnectedCalendar = _resolveComponent("ConnectedCalendar")!
  const _component_WeeklyDetailSchedule = _resolveComponent("WeeklyDetailSchedule")!
  const _component_CompleteToCreateVotedRoom = _resolveComponent("CompleteToCreateVotedRoom")!
  const _component_TutorialModal = _resolveComponent("TutorialModal")!
  const _component_LeftNavPanel = _resolveComponent("LeftNavPanel")!
  const _component_InputAstagNameModal = _resolveComponent("InputAstagNameModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_vue3_progress_bar),
    _createVNode(_component_FlashNotice),
    _createVNode(_component_LinkHeaderAvailableSchedule, {
      ref: "header",
      pageTitle: ``,
      buttonTitle: _ctx.isSP ? null : _ctx.headerTitle,
      buttonEnabled: _ctx.headerButtonEnabled,
      showChangeIcon: true,
      showWhatCal: true,
      showBackButton: true,
      clickChangeName: _ctx.clickChangeName,
      clickChangeAutoMode: _ctx.clickChangeAutoMode,
      from: `asview`,
      onClickPinkButton: _ctx.saveAvailableSchedule,
      onSelect: _ctx.selectTab
    }, null, 8, ["buttonTitle", "buttonEnabled", "clickChangeName", "clickChangeAutoMode", "onClickPinkButton", "onSelect"]),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.selectedTabName == `list`)
        ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (_ctx.showNewButton())
                ? (_openBlock(), _createElementBlock("section", {
                    key: 0,
                    class: "pointer centered circle_button pinkBg fs14 rad8 fw600 mr20",
                    style: {"width":"220px","height":"44px","padding":"11px 8px"},
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickNew && _ctx.clickNew(...args)))
                  }, " 新しい調整カレンダーを作成 "))
                : _createCommentVNode("", true),
              false
                ? (_openBlock(), _createElementBlock("section", {
                    key: 1,
                    class: "pointer centered circle_button with_white_bg fs14 rad8 fw600",
                    style: {"width":"220px","height":"44px","padding":"13px 8px","border":"1px solid #484848"},
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clickNewVote(true)))
                  }, [
                    _createElementVNode("img", {
                      src: _ctx.$getAssetImageUrl(`/assets/icons/vote.png`),
                      width: "25",
                      height: "25",
                      class: "fl pointer ml5",
                      style: {"margin-top":"-5px"}
                    }, null, 8, _hoisted_5),
                    _createTextVNode(" クイック投票を開始 ")
                  ]))
                : _createCommentVNode("", true)
            ]),
            _hoisted_6,
            (_ctx.rm.userInfo)
              ? (_openBlock(), _createBlock(_component_AstagClientLists, {
                  key: 0,
                  class: "mt10",
                  canDelete: true,
                  onSelectEnd: _ctx.selectEnd,
                  onCreateVotedRoom: _ctx.createVotedRoom
                }, null, 8, ["onSelectEnd", "onCreateVotedRoom"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(_component_RoomsLoader)
                ])),
            _hoisted_8
          ]))
        : (_ctx.selectedTabName == `detail`)
          ? (_openBlock(), _createElementBlock("section", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                (_ctx.cm.createType == `vote`)
                  ? (_openBlock(), _createBlock(_component_AppointmentCardViewSmall, {
                      key: 0,
                      appo: _ctx.rcm.appo,
                      editEditableContent: _ctx.editEditableContent
                    }, null, 8, ["appo", "editEditableContent"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_ConnectedCalendar)
              ]),
              _createElementVNode("section", _hoisted_11, [
                _createVNode(_component_WeeklyDetailSchedule, { ref: "WeeklyDetailSchedule" }, null, 512)
              ])
            ]))
          : (_ctx.selectedTabName == `complete`)
            ? (_openBlock(), _createElementBlock("section", _hoisted_12, [
                _createVNode(_component_CompleteToCreateVotedRoom, { currentClg: _ctx.currentClg }, null, 8, ["currentClg"])
              ]))
            : _createCommentVNode("", true),
      _hoisted_13
    ]),
    _createVNode(_component_TutorialModal, { tutorialType: `quick_vote` }),
    _createVNode(_component_LeftNavPanel, {
      ref: "leftPanel",
      panelType: _ctx.panelType
    }, null, 8, ["panelType"]),
    _createVNode(_component_InputAstagNameModal, {
      onCreateNew: _ctx.createNewAstag,
      createType: _ctx.createType,
      willCreateNewAstag: _ctx.willCreateNewAstag
    }, null, 8, ["onCreateNew", "createType", "willCreateNewAstag"])
  ]))
}